// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationOwnTheCheckoutPath = 'M48.7 35.1L34 20.5l5-5 9.7 9.7L64.9 9H58V2h20v20h-7v-9.2L48.7 35.1zm-14.387-7.6L19.076 42.95l.05.05H2v7h1.7a3.5 3.5 0 013.5 3.1l3.9 37.5a10.4 10.4 0 0010.4 9.4h57a10.4 10.4 0 0010.4-9.4l3.9-37.5a3.5 3.5 0 013.5-3.1H98v-7H78.9l-15-15-4.9 5 9.935 10H28.86l10.438-10.585-4.984-4.915zM13.6 50a10.3 10.3 0 01.5 2.4L18 89.9a3.5 3.5 0 003.5 3.1h57a3.5 3.5 0 003.5-3.1l3.9-37.5a10.3 10.3 0 01.5-2.4H13.6z M47 61h7v21h-7z M27.956 61.659L34.925 61l1.986 21.006-6.97.66-1.985-21.007zM63.947 82.006L65.933 61l6.969.659-1.986 21.006-6.97-.659z';
var IllustrationOwnTheCheckout = baseIllustration('IllustrationOwnTheCheckout', {
  getPath: () => IllustrationOwnTheCheckoutPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationOwnTheCheckout;
//# sourceMappingURL=index.js.map